import { Contact } from './../../pages/apps/Contacts/List/types';
import { ContactUsActionTypes } from './constants';

type ContactList = {
    contact_id: string;
    seq_id: string;
    label: string;
    value: string;
    icon: File | string;
    linking_url: string;
    created_at: string;
    update_at: string;
};

type ContactAdd = {
    label: string;
    value: string;
    icon: File | string;
    linking_url: string;
};

type ContactUpdate = {
    label: string;
    value: string;
    icon: File | string | null;
    linking_url: string;
    contact_id: string;
};

// In your types file
export type ContactUpdateSeq = {
    sequences: any;
};

export type ContactUsAction =
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST;
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST_SUCCESS;
          payload: {
              data: ContactList;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_LIST_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD;
          payload: {
              data: ContactAdd;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_ADD_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE;
          payload: {
              contact_id: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_DELETE_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE;
          payload: {
              data: ContactUpdate;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_ERROR;
          payload: {
              error: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ;
          payload: {
              data: ContactUpdateSeq;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ_SUCCESS;
          payload: {
              message: string;
          };
      }
    | {
          type: typeof ContactUsActionTypes.CONTACT_UPDATE_SEQ_ERROR;
          payload: {
              error: string;
          };
      };

// LIST
export const contactList = (): ContactUsAction => ({
    type: ContactUsActionTypes.CONTACT_LIST,
});

export const contactListSuccess = (data: ContactList | ContactList[]) => ({
    type: ContactUsActionTypes.CONTACT_LIST_SUCCESS,
    payload: { data },
});

export const contactListError = (error: string) => ({
    type: ContactUsActionTypes.CONTACT_LIST_ERROR,
    payload: { error },
});

// ADD
export const contactAdd = (data: any) => ({
    type: ContactUsActionTypes.CONTACT_ADD,
    payload: { data },
});

export const contactAddSuccess = (message: string) => ({
    type: ContactUsActionTypes.CONTACT_ADD_SUCCESS,
    payload: { message },
});

export const contactAddError = (error: string) => ({
    type: ContactUsActionTypes.CONTACT_ADD_ERROR,
    payload: { error },
});

// DELETE
export const contactDelete = (contact_id: string) => ({
    type: ContactUsActionTypes.CONTACT_DELETE,
    payload: { contact_id },
});

export const contactDeleteSuccess = (message: string) => ({
    type: ContactUsActionTypes.CONTACT_DELETE_SUCCESS,
    payload: { message },
});

export const contactDeleteError = (error: string) => ({
    type: ContactUsActionTypes.CONTACT_DELETE_ERROR,
    payload: { error },
});

// UPDATE
export const contactUpdate = (data: ContactUpdate) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE,
    payload: { data },
});

export const contactUpdateSuccess = (message: string) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE_SUCCESS,
    payload: { message },
});

export const contactUpdateError = (error: string) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE_ERROR,
    payload: { error },
});

// UPDATE SEQ
export const contactUpdateSeq = (data: ContactUpdateSeq) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE_SEQ,
    payload: { data },
});

export const contactUpdateSeqSuccess = (message: string) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE_SEQ_SUCCESS,
    payload: { message },
});

export const contactUpdateSeqError = (error: string) => ({
    type: ContactUsActionTypes.CONTACT_UPDATE_SEQ_ERROR,
    payload: { error },
});
